export default "__VITE_ASSET__a02b8628__"